module.exports = __webpack_public_path__ + "static/media/together.cbc0e812.png";